import React, { useEffect, useMemo, useState } from "react";
import SimpleBar from "simplebar-react";
import { Alert, Card, CardBody, Col, Spinner } from "reactstrap";
import { getDashboardReviewTotalsByReviewer } from "../../services/ValitanApiService";

const MAX_REVIEWERS = 8;

const Reviewers = () => {
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadReviewerSummary = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await getDashboardReviewTotalsByReviewer();
        const payload = response?.data?.data || {};
        const items = Array.isArray(payload?.reviewers) ? payload.reviewers : [];
        if (!isMounted) return;
        setReviewers(items);
      } catch (err) {
        if (!isMounted) return;
        console.error("Error loading reviewer summary:", err);
        setError("Failed to load reviewer summary.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadReviewerSummary();
    return () => {
      isMounted = false;
    };
  }, []);

  const reviewerSummary = useMemo(
    () =>
      reviewers
        .map((item, index) => ({
          key: item?.reviewerId || item?.reviewer_id || item?.reviewerName || `reviewer-${index}`,
          name: item?.reviewerName || item?.reviewer_name || "Unknown Reviewer",
          total: item?.assetCount || item?.asset_count || 0,
        }))
        .filter((item) => item.total > 0)
        .slice(0, MAX_REVIEWERS),
    [reviewers]
  );

  return (
    <Col md={12} lg={4}>
      <Card className="dashboard-widget">
        <CardBody>
          <div className="widget-header">
            <div>
              <h5 className="widget-title">Reviewers</h5>
              <p className="widget-copy">Asset review totals by reviewer.</p>
            </div>
            <div className="widget-chip">Reviewed</div>
          </div>

          {loading ? (
            <div className="py-4 text-center">
              <Spinner size="sm" color="primary" />
            </div>
          ) : error ? (
            <Alert color="danger" className="mb-0">
              {error}
            </Alert>
          ) : reviewerSummary.length === 0 ? (
            <Alert color="light" className="mb-0">
              No reviewed assets found.
            </Alert>
          ) : (
            <div className="pe-1">
              <SimpleBar style={{ maxHeight: "287px" }}>
                <div className="notice-list">
                  {reviewerSummary.map((item) => (
                    <div key={item.key} className="notice-item">
                      <div className="flex-shrink-0">
                        <div className="notice-icon">
                          <span>
                            <i className="ri-user-star-line" />
                          </span>
                        </div>
                      </div>

                      <div className="flex-grow-1 overflow-hidden">
                        <div className="notice-title mb-1">{item.name}</div>
                        <div className="notice-copy text-truncate">Reviewed asset activity</div>
                      </div>
                      <div className="notice-time">{item.total}</div>
                    </div>
                  ))}
                </div>
              </SimpleBar>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Reviewers;
